import { Bootstrap } from 'bootstrap';
import general from './general.js';
import offcanvasMenu from './components/offcanvasMenu.js';
import swiperComponents from './components/swiperComponents.js';
import lazyImgObserver from './intersectionObservers/lazyImgObserver.js';
import animationsObserver from './intersectionObservers/animationsObserver.js';
import animatedTextObserver from './intersectionObservers/animatedTextObserver.js';
import parallaxObserver from './intersectionObservers/parallaxObserver.js';
import heroWhyObserver from './intersectionObservers/heroWhyObserver.js';
import favoritesObserver from './intersectionObservers/favoriteObserver.js';
import swiperObserver from './intersectionObservers/swiperObserver.js';
import videoEmbed from './components/videoEmbed.js';
import expandablePriceTables from './components/expandablePriceTables.js';
import inputs from './components/inputs.js';
import loginModal from './components/loginModal.js';
import addToFavorites from './components/addToFavorites.js';
import childWidthCalculator from './components/childWidthCalculator.js';
import buttonClickOnce from './components/buttonClickOnce.js';
import smoothscroll from 'smoothscroll-polyfill';
import readMore from "./components/readMore.js";
import boostrapFix from "./components/bootstrapFix.js";

document.addEventListener('DOMContentLoaded', () => {
    smoothscroll.polyfill();
    general.init();
    favoritesObserver.init();
    addToFavorites.init();
    animatedTextObserver.init();
    loginModal.init();
    offcanvasMenu.init();

    swiperComponents.init();
    
    inputs.init();
    videoEmbed.init();
    expandablePriceTables.init();

    lazyImgObserver.init();
    swiperObserver.init();
    animationsObserver.init();
    heroWhyObserver.init();
    childWidthCalculator.init();
    parallaxObserver.init();
    buttonClickOnce.init();
    readMore.init();
    boostrapFix.init();
});